module.exports = {
    accessMode: 'free',
    storage: 'file',
    cawiUrl: 'https://srv7.cawi.fr/cgi-bin/devel/Q/cawibot5fr/cawibot5fr.pl',
    restartKeyword: 'RESTART',
    stopKeyword: 'STOP',
    whatsApp: {
        templateName: 'infobip_test_hsm',
        byeMessage: "Merci d'avoir complété ce questionnaire.", // TODO: shouldn't be useful ? (see bye.blk)
        debug: true
    }
}
